var exports = {
  "Lw": "VoiceSceneOverlay.module__overlay___QWpyVU",
  "WY": "VoiceSceneOverlay.module__nonCameraLayer___QWpyVU",
  "Y3": "VoiceSceneOverlay.module__anchor___QWpyVU",
  "my": "VoiceSceneOverlay.module__avatar___QWpyVU",
  "JA": "VoiceSceneOverlay.module__standing___QWpyVU",
  "Sx": "VoiceSceneOverlay.module__purr___QWpyVU",
  "xL": "VoiceSceneOverlay.module__marker___QWpyVU",
  "Vc": "VoiceSceneOverlay.module__markerTable___QWpyVU",
  "cK": "VoiceSceneOverlay.module__markerWatch___QWpyVU",
  "Fr": "VoiceSceneOverlay.module__tableLabel___QWpyVU",
  "vz": "VoiceSceneOverlay.module__backToTable___QWpyVU",
  "ju": "VoiceSceneOverlay.module__overflow___QWpyVU",
  "W_": "VoiceSceneOverlay.module__poster___QWpyVU",
  "AF": "VoiceSceneOverlay.module__posterWho___QWpyVU",
  "vO": "VoiceSceneOverlay.module__posterName___QWpyVU",
  "EE": "VoiceSceneOverlay.module__posterLive___QWpyVU",
  "sr": "VoiceSceneOverlay.module__voiceScenePosterLive___QWpyVU",
  "T3": "VoiceSceneOverlay.module__posterAnchor___QWpyVU",
  "nj": "VoiceSceneOverlay.module__screen___QWpyVU",
  "aq": "VoiceSceneOverlay.module__screenVideo___QWpyVU",
};

module.exports = exports;
